import { Component, Inject, OnInit, Optional } from "@angular/core";
import { FormGroupDirective } from "@angular/forms";
import { FormFieldType } from "../form-field.model";
import { FormFieldDirective } from "../form-field";

@Component({
    selector: "tc-input-field",
    templateUrl: "./input-field.component.html",
    styleUrls: ["./input-field.component.scss"],
    standalone: false
})
export class InputFieldComponent extends FormFieldDirective implements OnInit {
	constructor(
		@Optional()
		@Inject(FormGroupDirective)
		__formGroupDirective: FormGroupDirective
	) {
		super(__formGroupDirective);
	}

	ngOnInit(): void {
		this.type = FormFieldType.INPUT;
	}
}
